import { render, staticRenderFns } from "./AvatarCategoriesListFilter.vue?vue&type=template&id=44221437&"
import script from "./AvatarCategoriesListFilter.vue?vue&type=script&lang=js&"
export * from "./AvatarCategoriesListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports